const contractorClientsVisitsFiltersTemplate = {
    title: "",
    contractorUpdatedAt: "",
    location: "",
    managers: [],
};

export default contractorClientsVisitsFiltersTemplate;